import { CircularProgress } from '@mui/joy'
import { useImgLoad } from '~/shared/ui/Img/useImgLoad'
import { Wrapper } from './styled'

type ImgProps = {
  url: string
}

export function Img({ url }: ImgProps) {
  const { isLoading, imageUrl } = useImgLoad(url)

  return (
    <Wrapper>
      {isLoading && <CircularProgress size='sm' />}
      {!isLoading && imageUrl && <img src={imageUrl} alt='img' />}
    </Wrapper>
  )
}
